import { fieldsMapPaths } from "@Client/@Composables/application-standalone/validations/requiredValidationField";
import { camelCase, startCase } from "lodash";
export const getMappedPath = (pathName, prefix = "") => {
  var _fieldsMapPaths$camel;
  return (_fieldsMapPaths$camel = fieldsMapPaths[camelCase(prefix + startCase(pathName))]) != null ? _fieldsMapPaths$camel : "";
};